module.exports = __webpack_public_path__ + "static/media/pro-tip-reschedule.794a2b0a.png";